<div class="dialog-wraper">
    <div class="dialog-wraper-left">
        {{'machine_view.causal_popup.heading' | translate}}
    </div>
    <div class="dialog-wraper-right">
        <mat-dialog-actions class="dialog-close">
            <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close class="dialog-close-img"
                (click)="dialogClose()"
                (keydown)="($event.key === 'Enter' || $event.key === ' ') && dialogClose(); $event.preventDefault()">

        </mat-dialog-actions>
    </div>
</div>

<ng-container *ngIf="causalData && causalData.length > 0; else noData">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" aria-label="Causal Data">

        <ng-container matColumnDef="No">
            <th mat-header-cell *matHeaderCellDef scope="col"> {{ 'common.no' | translate }} </th>
            <td mat-cell *matCellDef="let element;let index = index" class="number-column"> {{index + 1}}
            </td>
        </ng-container>

        <ng-container matColumnDef="causalMachine">
            <th mat-header-cell *matHeaderCellDef scope="col"> {{ 'machine_view.causal_popup.causal' | translate }}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.causalMachine}} </td>
        </ng-container>

        <ng-container matColumnDef="causalDuration">
            <th mat-header-cell *matHeaderCellDef scope="col"> {{'machine_view.causal_popup.duration' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.duration | localDecimalPipe}}
                {{'machine_view.minutes_short' | translate}} </td>
        </ng-container>

        <ng-container matColumnDef="machineLoss">
            <th mat-header-cell *matHeaderCellDef scope="col">
                {{ 'machine_view.causal_popup.resultant_waste' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.machineLoss}} {{element?.machineUnit}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    </table>
</ng-container>
<ng-template #noData>
    <div class="no-data-wrapper">
        {{'search.no_data_found' | translate}}
    </div>
</ng-template>